import Collapsible from "app/components/Collapsible/Collapsible";
import InputWithLabel from "app/components/FormInputs/components/InputWithLabel/InputWithLabel";
import { registrationInputMaxLength } from "app/utils/const";
import { MouseEventHandler } from "react";
import {
  defineMessages,
  FormattedMessage,
  injectIntl,
  IntlShape,
} from "react-intl";
import AccountDetailsConfirmText from "./components/AccountDetailsConfirmText/AccountDetailsConfirmText";

type Props = {
  handleChange: Function;
  active: boolean;
  onClickConfirm: MouseEventHandler;
  errorMessage: string;
  emailErrorMessage: string;
  intl: IntlShape;
};

const AccountDetails: React.FC<Props> = (props: Props) => {
  const {
    handleChange,
    active,
    onClickConfirm,
    errorMessage,
    emailErrorMessage,
    intl,
  } = props;

  const I18n = defineMessages({
    username: {
      id: "home-username",
    },
    password: {
      id: "registrations-password",
    },
    email: {
      id: "home-email",
    },
  });

  // An input will be displayed for each field added here
  const fields = ["username", "password", "email"];

  return (
    <Collapsible
      onToggle={() => {
        handleChange("accountDetailsActive", !active);
      }}
      header={
        <div className="collapsible-header">
          <FormattedMessage id="home-register-account-details" />
        </div>
      }
      content={
        <div className="collapsible-content">
          <div className="account-details">
            {fields.map((field: string, index: number) => {
              const fieldLabel = I18n[field];

              let maxLength = registrationInputMaxLength.usernameMaxLength;

              if (field === "password") {
                maxLength = registrationInputMaxLength.passwordMaxLength;
              }
              if (field === "email") {
                maxLength = registrationInputMaxLength.emailMaxLength;
              }

              return (
                <InputWithLabel
                  label={intl.formatMessage({ id: fieldLabel.id })}
                  inputId={field}
                  value={props[field]}
                  onValueChange={handleChange}
                  key={index}
                  required={true}
                  maxLength={maxLength}
                />
              );
            })}
          </div>
          <div className="register-screen__form__error">
            {emailErrorMessage}
          </div>
          <div className="register-screen__form__messages">
            <FormattedMessage tagName="div" id="home-register-ensure-email" />
            <AccountDetailsConfirmText />
          </div>
          <div className="register-screen__form__error">{errorMessage}</div>
          <button
            type="submit"
            className="register-screen__form__submit-button"
            id="personal_details_submit_button"
            onClick={onClickConfirm}
          >
            <FormattedMessage
              tagName="span"
              id="home-register-confirm-continue"
            />
          </button>
        </div>
      }
      isActive={active}
      withArrows
    />
  );
};

export default injectIntl(AccountDetails);
